// extracted by mini-css-extract-plugin
export var container = "_5q-0";
export var disabled = "_5q-4";
export var fullWidth = "_5q-3";
export var lined = "_5q-1";
export var selected = "_5q-5";
export var tab = "_5q-2";